export const extractObjectFromList = (list: any[], attribute: string = 'id') => list.map(item => item[attribute]);
